import axios from "axios";
import { ca } from "date-fns/locale";

/*
  TODO:
    - extend this class to create two services
      - Token based WebService
      - ApiKey based WebService
*/


const DEFAULT_TIMEOUT_MS = 20000;

export class CoreService {
    constructor(session){
      this.session = session;

      this.axiosInstance = axios.create({ timeout: DEFAULT_TIMEOUT_MS });

      this.axiosInstance.interceptors.response.use(
        response => response,
        error => {
          if (error.response && error.response.status === 401) {
            console.log("Unauthorised");
            this.unauthorisedHandler && this.unauthorisedHandler();
          }
          return Promise.reject(error);
        }
      );
    }

    setUnauthorisedHandler = (handler)=>{
      this.unauthorisedHandler = handler;
    }

    needsToken = ()=> true

    getToken = ()=>{
      return this.session ? this.session.instance.idToken.jwtToken : '';
    }
  
    getBaseHeaders() {
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      };
      return headers;
    };

    callWebApi = async (method, url, data, idToken, extraHeaders = {}, timeoutMs) => {
      const headers = { ...this.getBaseHeaders(), ...extraHeaders };
      if(this.needsToken()) {
        headers['Authorization'] = idToken || this.getToken();
      }

      try {
        return await this.axiosInstance({
          method,
          url,
          headers,
          data,
          ...(timeoutMs ? { timeout: timeoutMs } : {})
        });
      } catch(err) {
        throw err;
      }
    }
}
